import { SalesOpportunities } from '@work4all/models/lib/Classes/SalesOpportunities.entity';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { LockProvider } from '../../../hooks';
import { useEntityPreviewData } from '../hooks/use-entity-preview-data';

import {
  SalesOpportunitiesHandlers,
  SalesOpportunitiesPreview,
} from './SalesOpportunitiesPreview';

export type ISalesOpportunitiesContainerProps = {
  ids: number[];
} & SalesOpportunitiesHandlers;

export const SalesOpportunitiesFields: SalesOpportunities<EMode.query> = {
  id: null,
  name: null,
  description: null,
  note: null,
  dateCreated: null,
  dateNextReview: null,
  decisionDate: null,
  groupId: null,
  probabilityPercent: null,
  creator: {
    id: null,
  },
  group: {
    id: null,
    name: null,
  },
  assignmentType: null,
  value: null,
  expectedCosts: null,
  orderValue: null,
  projectId: null,
  status: null,
  ratings: [
    {
      id: null,
      comment: null,
      value: null,
      status: null,
      ratingPercent: null,
      ratingDate: null,
    },
  ],
  ratingStatus: {
    id: null,
    name: null,
    ratingValue: null,
  },
  ratingStatusId: null,
  businessPartner: {
    id: null,
    businessPartnerType: null,
    data: {
      customer: {
        id: null,
        name: null,
        number: null,
        website: null,
      },
      supplier: {
        id: null,
        name: null,
        number: null,
        website: null,
      },
    },
  },
  contact: {
    id: null,
    displayName: null,
    businessPartnerId: null,
    businessPartnerType: null,
    eMail: null,
  },
  project: {
    id: null,
    name: null,
    number: null,
  },
  projectProcess: {
    id: null,
    process: null,
  },
  currency: {
    id: null,
    name: null,
  },
  kind: null,
};

export function SalesOpportunitiesContainer(
  props: ISalesOpportunitiesContainerProps
) {
  const { ids, ...handlers } = props;
  const entries = useEntityPreviewData<SalesOpportunities>(
    ids,
    Entities.salesOpportunities,
    SalesOpportunitiesFields
  );

  if (!entries) {
    return null;
  }

  return (
    <LockProvider>
      <SalesOpportunitiesPreview {...handlers} entries={entries} />
    </LockProvider>
  );
}
